// Fires a GA4 `page_view` event whenever the SPA route changes.
// The script tag in public/index.html disables the automatic initial page_view
// via `send_page_view: false`, so we send it once on mount and again on every
// route change.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export default function GAPageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID || typeof window === "undefined" || typeof window.gtag !== "function") {
      return;
    }
    const pagePath = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}
